import {Component, OnInit} from '@angular/core';
import {SharedService} from '../../services/shared.service';

@Component({
  selector: 'app-request-step-bar',
  templateUrl: './request-step-bar.component.html',
  styleUrls: ['./request-step-bar.component.scss']
})
export class RequestStepBarComponent implements OnInit {
  steps: Array<number> = [1, 2, 3, 4, 5];
  currentStep: number = 1;
  stepName: string = 'REQUEST.FUEL.NAME';

  constructor(private shared: SharedService) {
    this.shared.eventObservable.subscribe((event) => {
      if (event.type == 'request_step' && event.data) {
        this.currentStep = event.data.step;
        this.stepName = event.data.name;
      }
    });
  }

  stepsTrack(index) {
    return index;
  }

  ngOnInit() {
  }

}
